import Vue from 'vue';

Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err);
};
